/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as CallbackRouteImport } from './routes/callback'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthAssociatedServicesRouteImport } from './routes/_auth/associated-services'
import { Route as AuthCatalogRouteImport } from './routes/_auth/catalog'
import { Route as AuthDocumentsLinkageRouteImport } from './routes/_auth/documents-linkage'
import { Route as AuthFamilyLinkageRouteImport } from './routes/_auth/family-linkage'
import { Route as AuthLinkageMenuRouteImport } from './routes/_auth/linkage-menu'
import { Route as AuthPartRouteImport } from './routes/_auth/part'
import { Route as AuthProductMenuRouteImport } from './routes/_auth/product-menu'
import { Route as AuthProductSheetRouteImport } from './routes/_auth/product-sheet'
import { Route as AuthServiceLinkageRouteImport } from './routes/_auth/service-linkage'
import { Route as AuthSparePartSheetRouteImport } from './routes/_auth/spare-part-sheet'
import { Route as AuthAssociatedServicesIndexRouteImport } from './routes/_auth/associated-services.index'
import { Route as AuthAssociatedServicesServiceModelCodeRouteImport } from './routes/_auth/associated-services.$serviceModelCode'
import { Route as AuthPartIndexRouteImport } from './routes/_auth/part.index'
import { Route as AuthPartSearchTypeRouteImport } from './routes/_auth/part.$searchType'
import { Route as AuthProductSheetIndexRouteImport } from './routes/_auth/product-sheet.index'
import { Route as AuthProductSheetProductIdRouteImport } from './routes/_auth/product-sheet.$productId'
import { Route as AuthServiceLinkageIndexRouteImport } from './routes/_auth/service-linkage.index'
import { Route as AuthServiceLinkageServiceModelCodeRouteImport } from './routes/_auth/service-linkage.$serviceModelCode'
import { Route as AuthSparePartSheetIndexRouteImport } from './routes/_auth/spare-part-sheet.index'
import { Route as AuthSparePartSheetSparePartModelCodeRouteImport } from './routes/_auth/spare-part-sheet.$sparePartModelCode'
import { Route as AuthCatalogProcessesIndexRouteImport } from './routes/_auth/catalog.processes.index'
import { Route as AuthCatalogProcessesProcessIdCategoriesIndexRouteImport } from './routes/_auth/catalog.processes.$processId.categories.index'
import { Route as AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteImport } from './routes/_auth/catalog.processes.$processId.categories.$categoryId.products'
import { Route as AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRouteImport } from './routes/_auth/catalog.processes.$processId.categories.$categoryId.products.index'
import { Route as AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRouteImport } from './routes/_auth/catalog.processes.$processId.categories.$categoryId.products.$'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssociatedServicesRoute = AuthAssociatedServicesRouteImport.update({
  id: '/associated-services',
  path: '/associated-services',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCatalogRoute = AuthCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocumentsLinkageRoute = AuthDocumentsLinkageRouteImport.update({
  id: '/documents-linkage',
  path: '/documents-linkage',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFamilyLinkageRoute = AuthFamilyLinkageRouteImport.update({
  id: '/family-linkage',
  path: '/family-linkage',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLinkageMenuRoute = AuthLinkageMenuRouteImport.update({
  id: '/linkage-menu',
  path: '/linkage-menu',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPartRoute = AuthPartRouteImport.update({
  id: '/part',
  path: '/part',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductMenuRoute = AuthProductMenuRouteImport.update({
  id: '/product-menu',
  path: '/product-menu',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProductSheetRoute = AuthProductSheetRouteImport.update({
  id: '/product-sheet',
  path: '/product-sheet',
  getParentRoute: () => AuthRoute,
} as any)
const AuthServiceLinkageRoute = AuthServiceLinkageRouteImport.update({
  id: '/service-linkage',
  path: '/service-linkage',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSparePartSheetRoute = AuthSparePartSheetRouteImport.update({
  id: '/spare-part-sheet',
  path: '/spare-part-sheet',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAssociatedServicesIndexRoute =
  AuthAssociatedServicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAssociatedServicesRoute,
  } as any)
const AuthAssociatedServicesServiceModelCodeRoute =
  AuthAssociatedServicesServiceModelCodeRouteImport.update({
    id: '/$serviceModelCode',
    path: '/$serviceModelCode',
    getParentRoute: () => AuthAssociatedServicesRoute,
  } as any)
const AuthPartIndexRoute = AuthPartIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthPartRoute,
} as any)
const AuthPartSearchTypeRoute = AuthPartSearchTypeRouteImport.update({
  id: '/$searchType',
  path: '/$searchType',
  getParentRoute: () => AuthPartRoute,
} as any)
const AuthProductSheetIndexRoute = AuthProductSheetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthProductSheetRoute,
} as any)
const AuthProductSheetProductIdRoute =
  AuthProductSheetProductIdRouteImport.update({
    id: '/$productId',
    path: '/$productId',
    getParentRoute: () => AuthProductSheetRoute,
  } as any)
const AuthServiceLinkageIndexRoute = AuthServiceLinkageIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthServiceLinkageRoute,
} as any)
const AuthServiceLinkageServiceModelCodeRoute =
  AuthServiceLinkageServiceModelCodeRouteImport.update({
    id: '/$serviceModelCode',
    path: '/$serviceModelCode',
    getParentRoute: () => AuthServiceLinkageRoute,
  } as any)
const AuthSparePartSheetIndexRoute = AuthSparePartSheetIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSparePartSheetRoute,
} as any)
const AuthSparePartSheetSparePartModelCodeRoute =
  AuthSparePartSheetSparePartModelCodeRouteImport.update({
    id: '/$sparePartModelCode',
    path: '/$sparePartModelCode',
    getParentRoute: () => AuthSparePartSheetRoute,
  } as any)
const AuthCatalogProcessesIndexRoute =
  AuthCatalogProcessesIndexRouteImport.update({
    id: '/processes/',
    path: '/processes/',
    getParentRoute: () => AuthCatalogRoute,
  } as any)
const AuthCatalogProcessesProcessIdCategoriesIndexRoute =
  AuthCatalogProcessesProcessIdCategoriesIndexRouteImport.update({
    id: '/processes/$processId/categories/',
    path: '/processes/$processId/categories/',
    getParentRoute: () => AuthCatalogRoute,
  } as any)
const AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute =
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteImport.update({
    id: '/processes/$processId/categories/$categoryId/products',
    path: '/processes/$processId/categories/$categoryId/products',
    getParentRoute: () => AuthCatalogRoute,
  } as any)
const AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute =
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute,
    } as any,
  )
const AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute =
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRouteImport.update(
    {
      id: '/$',
      path: '/$',
      getParentRoute: () =>
        AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/callback': typeof CallbackRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/associated-services': typeof AuthAssociatedServicesRouteWithChildren
  '/catalog': typeof AuthCatalogRouteWithChildren
  '/documents-linkage': typeof AuthDocumentsLinkageRoute
  '/family-linkage': typeof AuthFamilyLinkageRoute
  '/linkage-menu': typeof AuthLinkageMenuRoute
  '/part': typeof AuthPartRouteWithChildren
  '/product-menu': typeof AuthProductMenuRoute
  '/product-sheet': typeof AuthProductSheetRouteWithChildren
  '/service-linkage': typeof AuthServiceLinkageRouteWithChildren
  '/spare-part-sheet': typeof AuthSparePartSheetRouteWithChildren
  '/associated-services/$serviceModelCode': typeof AuthAssociatedServicesServiceModelCodeRoute
  '/part/$searchType': typeof AuthPartSearchTypeRoute
  '/product-sheet/$productId': typeof AuthProductSheetProductIdRoute
  '/service-linkage/$serviceModelCode': typeof AuthServiceLinkageServiceModelCodeRoute
  '/spare-part-sheet/$sparePartModelCode': typeof AuthSparePartSheetSparePartModelCodeRoute
  '/associated-services/': typeof AuthAssociatedServicesIndexRoute
  '/part/': typeof AuthPartIndexRoute
  '/product-sheet/': typeof AuthProductSheetIndexRoute
  '/service-linkage/': typeof AuthServiceLinkageIndexRoute
  '/spare-part-sheet/': typeof AuthSparePartSheetIndexRoute
  '/catalog/processes/': typeof AuthCatalogProcessesIndexRoute
  '/catalog/processes/$processId/categories/': typeof AuthCatalogProcessesProcessIdCategoriesIndexRoute
  '/catalog/processes/$processId/categories/$categoryId/products': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteWithChildren
  '/catalog/processes/$processId/categories/$categoryId/products/$': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute
  '/catalog/processes/$processId/categories/$categoryId/products/': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute
}
export interface FileRoutesByTo {
  '/callback': typeof CallbackRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/catalog': typeof AuthCatalogRouteWithChildren
  '/documents-linkage': typeof AuthDocumentsLinkageRoute
  '/family-linkage': typeof AuthFamilyLinkageRoute
  '/linkage-menu': typeof AuthLinkageMenuRoute
  '/product-menu': typeof AuthProductMenuRoute
  '/': typeof AuthIndexRoute
  '/associated-services/$serviceModelCode': typeof AuthAssociatedServicesServiceModelCodeRoute
  '/part/$searchType': typeof AuthPartSearchTypeRoute
  '/product-sheet/$productId': typeof AuthProductSheetProductIdRoute
  '/service-linkage/$serviceModelCode': typeof AuthServiceLinkageServiceModelCodeRoute
  '/spare-part-sheet/$sparePartModelCode': typeof AuthSparePartSheetSparePartModelCodeRoute
  '/associated-services': typeof AuthAssociatedServicesIndexRoute
  '/part': typeof AuthPartIndexRoute
  '/product-sheet': typeof AuthProductSheetIndexRoute
  '/service-linkage': typeof AuthServiceLinkageIndexRoute
  '/spare-part-sheet': typeof AuthSparePartSheetIndexRoute
  '/catalog/processes': typeof AuthCatalogProcessesIndexRoute
  '/catalog/processes/$processId/categories': typeof AuthCatalogProcessesProcessIdCategoriesIndexRoute
  '/catalog/processes/$processId/categories/$categoryId/products/$': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute
  '/catalog/processes/$processId/categories/$categoryId/products': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/callback': typeof CallbackRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_auth/associated-services': typeof AuthAssociatedServicesRouteWithChildren
  '/_auth/catalog': typeof AuthCatalogRouteWithChildren
  '/_auth/documents-linkage': typeof AuthDocumentsLinkageRoute
  '/_auth/family-linkage': typeof AuthFamilyLinkageRoute
  '/_auth/linkage-menu': typeof AuthLinkageMenuRoute
  '/_auth/part': typeof AuthPartRouteWithChildren
  '/_auth/product-menu': typeof AuthProductMenuRoute
  '/_auth/product-sheet': typeof AuthProductSheetRouteWithChildren
  '/_auth/service-linkage': typeof AuthServiceLinkageRouteWithChildren
  '/_auth/spare-part-sheet': typeof AuthSparePartSheetRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/associated-services/$serviceModelCode': typeof AuthAssociatedServicesServiceModelCodeRoute
  '/_auth/part/$searchType': typeof AuthPartSearchTypeRoute
  '/_auth/product-sheet/$productId': typeof AuthProductSheetProductIdRoute
  '/_auth/service-linkage/$serviceModelCode': typeof AuthServiceLinkageServiceModelCodeRoute
  '/_auth/spare-part-sheet/$sparePartModelCode': typeof AuthSparePartSheetSparePartModelCodeRoute
  '/_auth/associated-services/': typeof AuthAssociatedServicesIndexRoute
  '/_auth/part/': typeof AuthPartIndexRoute
  '/_auth/product-sheet/': typeof AuthProductSheetIndexRoute
  '/_auth/service-linkage/': typeof AuthServiceLinkageIndexRoute
  '/_auth/spare-part-sheet/': typeof AuthSparePartSheetIndexRoute
  '/_auth/catalog/processes/': typeof AuthCatalogProcessesIndexRoute
  '/_auth/catalog/processes/$processId/categories/': typeof AuthCatalogProcessesProcessIdCategoriesIndexRoute
  '/_auth/catalog/processes/$processId/categories/$categoryId/products': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteWithChildren
  '/_auth/catalog/processes/$processId/categories/$categoryId/products/$': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute
  '/_auth/catalog/processes/$processId/categories/$categoryId/products/': typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/callback'
    | '/unauthorized'
    | '/associated-services'
    | '/catalog'
    | '/documents-linkage'
    | '/family-linkage'
    | '/linkage-menu'
    | '/part'
    | '/product-menu'
    | '/product-sheet'
    | '/service-linkage'
    | '/spare-part-sheet'
    | '/associated-services/$serviceModelCode'
    | '/part/$searchType'
    | '/product-sheet/$productId'
    | '/service-linkage/$serviceModelCode'
    | '/spare-part-sheet/$sparePartModelCode'
    | '/associated-services/'
    | '/part/'
    | '/product-sheet/'
    | '/service-linkage/'
    | '/spare-part-sheet/'
    | '/catalog/processes/'
    | '/catalog/processes/$processId/categories/'
    | '/catalog/processes/$processId/categories/$categoryId/products'
    | '/catalog/processes/$processId/categories/$categoryId/products/$'
    | '/catalog/processes/$processId/categories/$categoryId/products/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/callback'
    | '/unauthorized'
    | '/catalog'
    | '/documents-linkage'
    | '/family-linkage'
    | '/linkage-menu'
    | '/product-menu'
    | '/'
    | '/associated-services/$serviceModelCode'
    | '/part/$searchType'
    | '/product-sheet/$productId'
    | '/service-linkage/$serviceModelCode'
    | '/spare-part-sheet/$sparePartModelCode'
    | '/associated-services'
    | '/part'
    | '/product-sheet'
    | '/service-linkage'
    | '/spare-part-sheet'
    | '/catalog/processes'
    | '/catalog/processes/$processId/categories'
    | '/catalog/processes/$processId/categories/$categoryId/products/$'
    | '/catalog/processes/$processId/categories/$categoryId/products'
  id:
    | '__root__'
    | '/_auth'
    | '/callback'
    | '/unauthorized'
    | '/_auth/associated-services'
    | '/_auth/catalog'
    | '/_auth/documents-linkage'
    | '/_auth/family-linkage'
    | '/_auth/linkage-menu'
    | '/_auth/part'
    | '/_auth/product-menu'
    | '/_auth/product-sheet'
    | '/_auth/service-linkage'
    | '/_auth/spare-part-sheet'
    | '/_auth/'
    | '/_auth/associated-services/$serviceModelCode'
    | '/_auth/part/$searchType'
    | '/_auth/product-sheet/$productId'
    | '/_auth/service-linkage/$serviceModelCode'
    | '/_auth/spare-part-sheet/$sparePartModelCode'
    | '/_auth/associated-services/'
    | '/_auth/part/'
    | '/_auth/product-sheet/'
    | '/_auth/service-linkage/'
    | '/_auth/spare-part-sheet/'
    | '/_auth/catalog/processes/'
    | '/_auth/catalog/processes/$processId/categories/'
    | '/_auth/catalog/processes/$processId/categories/$categoryId/products'
    | '/_auth/catalog/processes/$processId/categories/$categoryId/products/$'
    | '/_auth/catalog/processes/$processId/categories/$categoryId/products/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  CallbackRoute: typeof CallbackRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/associated-services': {
      id: '/_auth/associated-services'
      path: '/associated-services'
      fullPath: '/associated-services'
      preLoaderRoute: typeof AuthAssociatedServicesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/catalog': {
      id: '/_auth/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof AuthCatalogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/documents-linkage': {
      id: '/_auth/documents-linkage'
      path: '/documents-linkage'
      fullPath: '/documents-linkage'
      preLoaderRoute: typeof AuthDocumentsLinkageRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/family-linkage': {
      id: '/_auth/family-linkage'
      path: '/family-linkage'
      fullPath: '/family-linkage'
      preLoaderRoute: typeof AuthFamilyLinkageRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/linkage-menu': {
      id: '/_auth/linkage-menu'
      path: '/linkage-menu'
      fullPath: '/linkage-menu'
      preLoaderRoute: typeof AuthLinkageMenuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/part': {
      id: '/_auth/part'
      path: '/part'
      fullPath: '/part'
      preLoaderRoute: typeof AuthPartRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product-menu': {
      id: '/_auth/product-menu'
      path: '/product-menu'
      fullPath: '/product-menu'
      preLoaderRoute: typeof AuthProductMenuRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/product-sheet': {
      id: '/_auth/product-sheet'
      path: '/product-sheet'
      fullPath: '/product-sheet'
      preLoaderRoute: typeof AuthProductSheetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/service-linkage': {
      id: '/_auth/service-linkage'
      path: '/service-linkage'
      fullPath: '/service-linkage'
      preLoaderRoute: typeof AuthServiceLinkageRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/spare-part-sheet': {
      id: '/_auth/spare-part-sheet'
      path: '/spare-part-sheet'
      fullPath: '/spare-part-sheet'
      preLoaderRoute: typeof AuthSparePartSheetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/associated-services/': {
      id: '/_auth/associated-services/'
      path: '/'
      fullPath: '/associated-services/'
      preLoaderRoute: typeof AuthAssociatedServicesIndexRouteImport
      parentRoute: typeof AuthAssociatedServicesRoute
    }
    '/_auth/associated-services/$serviceModelCode': {
      id: '/_auth/associated-services/$serviceModelCode'
      path: '/$serviceModelCode'
      fullPath: '/associated-services/$serviceModelCode'
      preLoaderRoute: typeof AuthAssociatedServicesServiceModelCodeRouteImport
      parentRoute: typeof AuthAssociatedServicesRoute
    }
    '/_auth/part/': {
      id: '/_auth/part/'
      path: '/'
      fullPath: '/part/'
      preLoaderRoute: typeof AuthPartIndexRouteImport
      parentRoute: typeof AuthPartRoute
    }
    '/_auth/part/$searchType': {
      id: '/_auth/part/$searchType'
      path: '/$searchType'
      fullPath: '/part/$searchType'
      preLoaderRoute: typeof AuthPartSearchTypeRouteImport
      parentRoute: typeof AuthPartRoute
    }
    '/_auth/product-sheet/': {
      id: '/_auth/product-sheet/'
      path: '/'
      fullPath: '/product-sheet/'
      preLoaderRoute: typeof AuthProductSheetIndexRouteImport
      parentRoute: typeof AuthProductSheetRoute
    }
    '/_auth/product-sheet/$productId': {
      id: '/_auth/product-sheet/$productId'
      path: '/$productId'
      fullPath: '/product-sheet/$productId'
      preLoaderRoute: typeof AuthProductSheetProductIdRouteImport
      parentRoute: typeof AuthProductSheetRoute
    }
    '/_auth/service-linkage/': {
      id: '/_auth/service-linkage/'
      path: '/'
      fullPath: '/service-linkage/'
      preLoaderRoute: typeof AuthServiceLinkageIndexRouteImport
      parentRoute: typeof AuthServiceLinkageRoute
    }
    '/_auth/service-linkage/$serviceModelCode': {
      id: '/_auth/service-linkage/$serviceModelCode'
      path: '/$serviceModelCode'
      fullPath: '/service-linkage/$serviceModelCode'
      preLoaderRoute: typeof AuthServiceLinkageServiceModelCodeRouteImport
      parentRoute: typeof AuthServiceLinkageRoute
    }
    '/_auth/spare-part-sheet/': {
      id: '/_auth/spare-part-sheet/'
      path: '/'
      fullPath: '/spare-part-sheet/'
      preLoaderRoute: typeof AuthSparePartSheetIndexRouteImport
      parentRoute: typeof AuthSparePartSheetRoute
    }
    '/_auth/spare-part-sheet/$sparePartModelCode': {
      id: '/_auth/spare-part-sheet/$sparePartModelCode'
      path: '/$sparePartModelCode'
      fullPath: '/spare-part-sheet/$sparePartModelCode'
      preLoaderRoute: typeof AuthSparePartSheetSparePartModelCodeRouteImport
      parentRoute: typeof AuthSparePartSheetRoute
    }
    '/_auth/catalog/processes/': {
      id: '/_auth/catalog/processes/'
      path: '/processes'
      fullPath: '/catalog/processes/'
      preLoaderRoute: typeof AuthCatalogProcessesIndexRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/processes/$processId/categories/': {
      id: '/_auth/catalog/processes/$processId/categories/'
      path: '/processes/$processId/categories'
      fullPath: '/catalog/processes/$processId/categories/'
      preLoaderRoute: typeof AuthCatalogProcessesProcessIdCategoriesIndexRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/processes/$processId/categories/$categoryId/products': {
      id: '/_auth/catalog/processes/$processId/categories/$categoryId/products'
      path: '/processes/$processId/categories/$categoryId/products'
      fullPath: '/catalog/processes/$processId/categories/$categoryId/products'
      preLoaderRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteImport
      parentRoute: typeof AuthCatalogRoute
    }
    '/_auth/catalog/processes/$processId/categories/$categoryId/products/': {
      id: '/_auth/catalog/processes/$processId/categories/$categoryId/products/'
      path: '/'
      fullPath: '/catalog/processes/$processId/categories/$categoryId/products/'
      preLoaderRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRouteImport
      parentRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute
    }
    '/_auth/catalog/processes/$processId/categories/$categoryId/products/$': {
      id: '/_auth/catalog/processes/$processId/categories/$categoryId/products/$'
      path: '/$'
      fullPath: '/catalog/processes/$processId/categories/$categoryId/products/$'
      preLoaderRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRouteImport
      parentRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute
    }
  }
}

interface AuthAssociatedServicesRouteChildren {
  AuthAssociatedServicesServiceModelCodeRoute: typeof AuthAssociatedServicesServiceModelCodeRoute
  AuthAssociatedServicesIndexRoute: typeof AuthAssociatedServicesIndexRoute
}

const AuthAssociatedServicesRouteChildren: AuthAssociatedServicesRouteChildren =
  {
    AuthAssociatedServicesServiceModelCodeRoute:
      AuthAssociatedServicesServiceModelCodeRoute,
    AuthAssociatedServicesIndexRoute: AuthAssociatedServicesIndexRoute,
  }

const AuthAssociatedServicesRouteWithChildren =
  AuthAssociatedServicesRoute._addFileChildren(
    AuthAssociatedServicesRouteChildren,
  )

interface AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteChildren {
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute
}

const AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteChildren: AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteChildren =
  {
    AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute:
      AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsSplatRoute,
    AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute:
      AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsIndexRoute,
  }

const AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteWithChildren =
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute._addFileChildren(
    AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteChildren,
  )

interface AuthCatalogRouteChildren {
  AuthCatalogProcessesIndexRoute: typeof AuthCatalogProcessesIndexRoute
  AuthCatalogProcessesProcessIdCategoriesIndexRoute: typeof AuthCatalogProcessesProcessIdCategoriesIndexRoute
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute: typeof AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteWithChildren
}

const AuthCatalogRouteChildren: AuthCatalogRouteChildren = {
  AuthCatalogProcessesIndexRoute: AuthCatalogProcessesIndexRoute,
  AuthCatalogProcessesProcessIdCategoriesIndexRoute:
    AuthCatalogProcessesProcessIdCategoriesIndexRoute,
  AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRoute:
    AuthCatalogProcessesProcessIdCategoriesCategoryIdProductsRouteWithChildren,
}

const AuthCatalogRouteWithChildren = AuthCatalogRoute._addFileChildren(
  AuthCatalogRouteChildren,
)

interface AuthPartRouteChildren {
  AuthPartSearchTypeRoute: typeof AuthPartSearchTypeRoute
  AuthPartIndexRoute: typeof AuthPartIndexRoute
}

const AuthPartRouteChildren: AuthPartRouteChildren = {
  AuthPartSearchTypeRoute: AuthPartSearchTypeRoute,
  AuthPartIndexRoute: AuthPartIndexRoute,
}

const AuthPartRouteWithChildren = AuthPartRoute._addFileChildren(
  AuthPartRouteChildren,
)

interface AuthProductSheetRouteChildren {
  AuthProductSheetProductIdRoute: typeof AuthProductSheetProductIdRoute
  AuthProductSheetIndexRoute: typeof AuthProductSheetIndexRoute
}

const AuthProductSheetRouteChildren: AuthProductSheetRouteChildren = {
  AuthProductSheetProductIdRoute: AuthProductSheetProductIdRoute,
  AuthProductSheetIndexRoute: AuthProductSheetIndexRoute,
}

const AuthProductSheetRouteWithChildren =
  AuthProductSheetRoute._addFileChildren(AuthProductSheetRouteChildren)

interface AuthServiceLinkageRouteChildren {
  AuthServiceLinkageServiceModelCodeRoute: typeof AuthServiceLinkageServiceModelCodeRoute
  AuthServiceLinkageIndexRoute: typeof AuthServiceLinkageIndexRoute
}

const AuthServiceLinkageRouteChildren: AuthServiceLinkageRouteChildren = {
  AuthServiceLinkageServiceModelCodeRoute:
    AuthServiceLinkageServiceModelCodeRoute,
  AuthServiceLinkageIndexRoute: AuthServiceLinkageIndexRoute,
}

const AuthServiceLinkageRouteWithChildren =
  AuthServiceLinkageRoute._addFileChildren(AuthServiceLinkageRouteChildren)

interface AuthSparePartSheetRouteChildren {
  AuthSparePartSheetSparePartModelCodeRoute: typeof AuthSparePartSheetSparePartModelCodeRoute
  AuthSparePartSheetIndexRoute: typeof AuthSparePartSheetIndexRoute
}

const AuthSparePartSheetRouteChildren: AuthSparePartSheetRouteChildren = {
  AuthSparePartSheetSparePartModelCodeRoute:
    AuthSparePartSheetSparePartModelCodeRoute,
  AuthSparePartSheetIndexRoute: AuthSparePartSheetIndexRoute,
}

const AuthSparePartSheetRouteWithChildren =
  AuthSparePartSheetRoute._addFileChildren(AuthSparePartSheetRouteChildren)

interface AuthRouteChildren {
  AuthAssociatedServicesRoute: typeof AuthAssociatedServicesRouteWithChildren
  AuthCatalogRoute: typeof AuthCatalogRouteWithChildren
  AuthDocumentsLinkageRoute: typeof AuthDocumentsLinkageRoute
  AuthFamilyLinkageRoute: typeof AuthFamilyLinkageRoute
  AuthLinkageMenuRoute: typeof AuthLinkageMenuRoute
  AuthPartRoute: typeof AuthPartRouteWithChildren
  AuthProductMenuRoute: typeof AuthProductMenuRoute
  AuthProductSheetRoute: typeof AuthProductSheetRouteWithChildren
  AuthServiceLinkageRoute: typeof AuthServiceLinkageRouteWithChildren
  AuthSparePartSheetRoute: typeof AuthSparePartSheetRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAssociatedServicesRoute: AuthAssociatedServicesRouteWithChildren,
  AuthCatalogRoute: AuthCatalogRouteWithChildren,
  AuthDocumentsLinkageRoute: AuthDocumentsLinkageRoute,
  AuthFamilyLinkageRoute: AuthFamilyLinkageRoute,
  AuthLinkageMenuRoute: AuthLinkageMenuRoute,
  AuthPartRoute: AuthPartRouteWithChildren,
  AuthProductMenuRoute: AuthProductMenuRoute,
  AuthProductSheetRoute: AuthProductSheetRouteWithChildren,
  AuthServiceLinkageRoute: AuthServiceLinkageRouteWithChildren,
  AuthSparePartSheetRoute: AuthSparePartSheetRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  CallbackRoute: CallbackRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
